import BaseModel from '@core/model';

import BillingGroupApi from '@packages/rate-plans/billing-groups/api';

import Investor from '@/models/Investor';

export class BillingGroup extends BaseModel {
    static name = 'BillingGroup';
    static entity = 'billingGroups';
    static Api = BillingGroupApi;

    static fields() {
        return {
            ...super.fields(),
            id: this.attr(null),
            name: this.string(null).nullable(),
            investor_id: this.string(null).nullable(),
            adviser_id: this.string(null).nullable(),
            investors_count: this.number(null).nullable(),
            investor_ids: this.attr([]).nullable(),
            investors: this.modelList(Investor, []),
            deleted_at: this.string(null).nullable(),
            active_subscriptions: this.attr([]).nullable(),
            upcoming_subscriptions: this.attr([]).nullable()
        };
    }

    get has_multiple_investors() {
        if (typeof this.investors_count === 'number') {
            return this.investors_count > 1;
        }

        return Array.isArray(this.investors) && this.investors.length > 1;
    }

    static mock(overrides = {}) {
        const deprecated = !!overrides.deprecated;

        return {
            id: faker => faker.string.uuid(),
            name: faker => faker.person.fullName(),
            investor_id: faker => overrides.investor_id || faker.string.uuid(),
            adviser_id: faker => overrides.adviser_id || faker.string.uuid(),
            investors_count: faker => faker.number.int({ min: 1, max: 3 }),
            active_subscriptions: Array.isArray(overrides.active_subscriptions)
                ? () => overrides.active_subscriptions
                : faker => {
                      const adviserId = overrides.adviser_id || faker.string.uuid();
                      const adviserStatus = deprecated ? 'DEPRECATED' : 'ACTIVE';
                      const adviserEndDate = deprecated ? '2025-12-31' : null;
                      const adviserDescription = deprecated
                          ? 'This plan has been retired and is no longer available for new subscriptions.'
                          : 'Inherited adviser plan';

                      return [
                          {
                              start_date: '2024-01-01',
                              end_date: adviserEndDate,
                              rate_plan_type: 'ADVISER',
                              rate_plan: {
                                  id: `adviser-plan-${adviserId}`,
                                  name: 'Inherited adviser plan',
                                  status: adviserStatus,
                                  type: 'ADVISER',
                                  description: adviserDescription,
                                  default: false,
                                  adviser_id: adviserId
                              }
                          },
                          {
                              start_date: '2024-01-01',
                              end_date: null,
                              rate_plan_type: 'PLATFORM',
                              rate_plan: {
                                  id: `platform-plan-${adviserId}`,
                                  name: 'Inherited platform plan',
                                  status: 'ACTIVE',
                                  type: 'PLATFORM',
                                  description: 'Inherited platform plan',
                                  default: false,
                                  adviser_id: adviserId
                              }
                          }
                      ];
                  }
        };
    }
}

export default BillingGroup;
